export const API_OMS_URL = process.env.VUE_APP_API_OMS_URL;
export default (API_OMS_URL);